// MainContent.jsx
import useTabStore from '../../stores/useMainContentTab.jsx'
import StartContent from './ContentComponents/StartContent.jsx'
import ThankyouContent from './ContentComponents/ThankyouContent.jsx'
import MainReactContent from './MainReactContent.jsx'

export default function MainContent() {
    const { mainContentTab } = useTabStore()

    console.log(mainContentTab)

    let content

    switch (mainContentTab) {
        case "StartScreen":
            content = (
                <StartContent />
            )
            break
        case "MainContentScreen":
            content = (
                <MainReactContent />
            )
            break
        case "ThankyouScreen":
            content = (
                <ThankyouContent />
            )
            break
        default:
            content = <div>
                Default foreground content
            </div>
    }
    return (
        <div className="relative z-10 min-h-svh bg-transparent">
            {content}
        </div>
    )
}
